<template>
  <div>
    <v-layout
      column
      data-v-step="7"      
    >
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            title="Zoom inn"
            aria-label="Zoom inn"
            @focus="hideInfoDrawer"
            text
            v-on="on"
            class="zoom-button"
            
            @click="zoomIn()"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Zoom inn</span>
      </v-tooltip>
      <v-divider />
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            title="Zoom ut"
            aria-label="Zoom ut"
            text
            class="zoom-button"
            
            v-on="on"
            @click="zoomOut()"
          >
            <v-icon>mdi-minus</v-icon>
          </v-btn>
        </template>
        <span>Zoom ut</span>
      </v-tooltip>
    </v-layout>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
export default {
  name: "MapZoomNavigation",  
  data: function () {
    return {
      zoomViewModel: null
    };
  },
  props: {
    mapView: Object
  },
  computed: {
    showInfoDrawer: {
      get () {
        return this.$store.state.showInfoDrawer;
      },
      set (newValue) {
        return this.$store.dispatch("setShowInfoDrawer", newValue);
      }
    }
  },
  methods: {
    zoomIn: function () {
      this.zoomViewModel.zoomIn();
    },
    zoomOut: function () {
      this.zoomViewModel.zoomOut();
    },
    hideInfoDrawer: function () {
      this.showInfoDrawer = false;
    },
    loadZoom: function () {
      loadModules(["esri/widgets/Zoom/ZoomViewModel"]).then(
        function ([ZoomViewModel]) {

          this.zoomViewModel = new ZoomViewModel({
            view: this.mapView
          });
        }.bind(this)
      );
    }
  },
  mounted () {
    this.loadZoom();
  }
};
</script>

<style>
.zoom-button {
  max-width: 40px !important;
  min-width: 40px !important;
  max-height: 40px !important;
  margin: 0px;
  border-radius: 0px;
}
</style>
